import { classnames as cx } from '@carvana/merch-search/utilities';
import { useContext } from 'react';
import { isProd } from '~/constants/environment';
import FinancingType from '~/constants/FinancingType';
import { useFinanceType } from '~/contexts/FinanceAndTradeContext';
import SearchContext from '~/contexts/SearchContext';
import { useHasActiveTradeApplied } from '~/hooks/selectors';
import GreyCheckMarkIcon from './GreyCheckMarkIcon';
import MonthlyPayment from './MonthlyPayment';
import PricingErrorTooltip from './PricingErrorTooltip';
import { useHasFinanceFailed, usePriceTerms } from '../hooks';

const formatPrice = (price: number): string => Number(price).toLocaleString();

export default function Terms(): JSX.Element | null {
  const { pricingErrorMessage, totalCashDue = 0 } = usePriceTerms();

  const hasIndividualFinanceFailed = useHasFinanceFailed();
  const hasTradeIn = useHasActiveTradeApplied();
  const hasValidTerms = useFinanceType() === FinancingType.UserFinancing;
  const { showFinance } = useContext(SearchContext);
  const hidden = !showFinance;

  if (hasIndividualFinanceFailed) {
    return null;
  }

  if (pricingErrorMessage && !isProd) {
    return (
      <div
        data-qa="base-terms"
        className={cx('flex mb-20 mr-16 self-end text-sm z-100', 'bold', {
          hidden
        })}
      >
        <PricingErrorTooltip pricingErrorMessage={pricingErrorMessage} />
      </div>
    );
  }

  return (
    <div
      data-qa="base-terms"
      className={cx('flex flex-col items-end justify-end text-grey-5 text-sm', {
        hidden
      })}
    >
      <MonthlyPayment hasValidTerms={hasValidTerms} />

      <div
        data-down-payment={totalCashDue}
        className={cx('', {
          'font-bold text-blue-6': totalCashDue === 0
        })}
        data-qa="down-payment"
      >
        ${formatPrice(totalCashDue)} due at order
      </div>

      {hasTradeIn && (
        <div className="flex gap-4 items-center">
          <GreyCheckMarkIcon /> Trade applied
        </div>
      )}
    </div>
  );
}
